// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SqOI","title":"styles_title__1QGzu"};